import React from 'react'
import { toast } from 'react-toastify'
import {
    Badge,
    ToastMessage,
    Button,
} from '@forge/common'

/*INFO:
notificationType:
-success
-error
-warning
-progress => information toast
-neutral

toastPosition:
-top-right
-top-center
-top-left
-bottom-right
-bottom-center
-bottom-left
*/

const ToastNotification = ({
    notificationType = '',
    badgeTitle = '',
    title = '',
    subtitle = '',
    content = '',
    footerButtonText = '',
    toastPosition = 'top-right',
    isDark = false,
    showClose = true,
    showDismiss = false,
    handleFooterButton = null,
    onClose = () => {}
}) => {
    return (
        toast(<ToastMessage
            type={<Badge type={notificationType}>{badgeTitle}</Badge>}
            title={title}
            subtitle={subtitle}
            content={content}
            showClose={showClose}
            showDismiss={showDismiss}
            footer={handleFooterButton === null ? null : <Button  style={{ fontWeight: '600'}}onClick={handleFooterButton}>{footerButtonText}</Button>}
        />,
        {
            className: 'forge-notification-toast' + ` ${isDark ? 'dark' : null}`,
            position: toastPosition,
            onClose: onClose
        })
    )
}

export {
    ToastNotification
}
